var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTonActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 29.229,
    viewBox: "0 0 26 29.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 26,
    height: 29.229,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M26,20.64V8.589a2.564,2.564,0,0,0-1.282-2.22L14.282.344a2.564,2.564,0,0,0-2.564,0L1.282,6.369A2.564,2.564,0,0,0,0,8.589V20.64a2.564,2.564,0,0,0,1.282,2.22l10.436,6.025a2.564,2.564,0,0,0,2.564,0L24.718,22.86A2.564,2.564,0,0,0,26,20.64",
    transform: "translate(0 0)",
    fill: "#8ebe78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M27.88,24.017V14.379a2.564,2.564,0,0,0-1.282-2.22L18.252,7.34a2.566,2.566,0,0,0-2.564,0L7.342,12.159a2.564,2.564,0,0,0-1.282,2.22v9.637a2.564,2.564,0,0,0,1.282,2.22l8.346,4.819a2.564,2.564,0,0,0,2.564,0L26.6,26.237a2.564,2.564,0,0,0,1.282-2.22",
    transform: "translate(-3.97 -4.583)",
    fill: "#d3fac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M29.592,38.282l-3.563,1.872.681-3.968-2.883-2.809L27.81,32.8l1.782-3.611L31.374,32.8l3.983.578-2.882,2.809.681,3.968Z",
    transform: "translate(-16.592 -20.057)",
    fill: "#6ea853"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonActive);
export default __webpack_public_path__ + "static/media/ton-active.1697735dd205a0c5ba87733726610bd9.svg";
export { ForwardRef as ReactComponent };